var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBingSpecifics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 19,
    viewBox: "0 0 13 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L3.71246 1.33594V14.6953L8.94197 11.609L6.37832 10.3799L4.7608 6.26406L13 9.22331V13.5256L3.71536 19L0 16.8874V0Z",
    fill: "#112240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBingSpecifics);
export default __webpack_public_path__ + "static/media/icon-bing-specifics.d65d9be9.svg";
export { ForwardRef as ReactComponent };